function _strcmp(a, b) {
	if (a == b) return 0;
	return a < b ? -1 : 1;
}

export function userNameCmp(u, v) {
	return _strcmp(u.last_name.toLowerCase(), v.last_name.toLowerCase())
		|| _strcmp(u.first_name.toLowerCase(), v.first_name.toLowerCase())
		|| 0;
}
